import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useResultShareBlockStyles = makeStyles(() => ({
  shareBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  shareRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    padding: '16px 0',
    borderTop: '1px solid rgba(122, 101, 85, 0.24)',
    borderBottom: '1px solid rgba(122, 101, 85, 0.24)',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: 16,
      rowGap: 12,
    },
  },
  shareTitle: {
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    color: '#18181b',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
  },
  shareIcons: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 20,
    height: 20,
    '& button': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      lineHeight: 0,
      verticalAlign: 'middle',
    },
  },
  shareIconButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.primaryDark,
    lineHeight: 0,
    '& svg': {
      display: 'block',
      width: 16,
      height: 16,
    },
  },
  copyLinkButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    flex: '1 1 0',
    minWidth: 0,
    height: 40,
    padding: '0 24px',
    border: 0,
    borderRadius: radius.sm,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    letterSpacing: 0.28,
    whiteSpace: 'nowrap',
    transition: 'opacity 0.15s ease, transform 0.1s ease',
    '&:hover': {
      opacity: 0.92,
    },
    '&:active': {
      opacity: 0.84,
      transform: 'scale(0.98)',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flex: '1 1 100%',
      width: '100%',
      padding: '0 16px',
    },
  },
  helpRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 40,
    padding: '16px 0',
    borderBottom: '1px solid rgba(122, 101, 85, 0.24)',
    cursor: 'pointer',
  },
  helpLabels: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },
  helpTitle: {
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    letterSpacing: 0.28,
    whiteSpace: 'nowrap',
  },
  helpContact: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.textBody,
    letterSpacing: 0.24,
    whiteSpace: 'nowrap',
  },
  helpIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0 24px',
    flexShrink: 0,
  },
  helpIcon: {
    width: 16,
    height: 16,
    color: colors.primaryDark,
  },
}));
